<h1>
    Edit Scholarship for:
    <span class="text-orange-400">{{ scholarship?.ScholarshipName }}</span>
</h1>
<mat-divider></mat-divider>
<p>
    Edit any values in the form below to change scholarship information.
    <strong>Note: Each tab has it's own save button!</strong>
</p>

<div class="flex flex-col items-center">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" dynamicHeight class="w-[900px]">
        <mat-tab label="Requirements">
            @if (loading === false) {
            <form [formGroup]="requirementsForm" (ngSubmit)="requirementsSave(requirementsForm)">
                <div class="flex flex-col items-center p-[30px]">
                    <mat-form-field class="w-[90%]">
                        <mat-label>Scholarhip Name</mat-label>
                        <input matInput formControlName="ScholarshipName" required maxlength="200" />
                        @if (requirementsForm.get('ScholarshipName').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Scholarship Overview / Selection
                            Criteria</mat-label>
                        <textarea matInput formControlName="Description" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="3000" #description></textarea>
                        <mat-hint align="end">{{ description.value.length }}/3000</mat-hint>
                        @if (requirementsForm.get('Description').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>

                    <mat-radio-group formControlName="Active" class="flex justify-between my-[10px] w-[90%]">
                        <mat-label>Scholarhip Status</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Active</mat-radio-button>
                            <mat-radio-button [value]="false">Inactive</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="Advertised" class="flex justify-between my-[10px] w-[90%]">
                        <mat-label>Advertised?</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Advertised</mat-radio-button>
                            <mat-radio-button [value]="false">Not Advertised</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Minimum GPA</mat-label>
                        <input matInput formControlName="MinGPA" />
                        @if (requirementsForm.get('MinGPA').hasError('validateDecimal')) {
                        <mat-error>invalid response</mat-error>
                        }
                        <mat-hint>numbers only</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Minimum SAT</mat-label>
                        <input matInput formControlName="MinSAT" />
                        @if (requirementsForm.get('MinSAT').hasError('validateNumber')) {
                        <mat-error>invalid response</mat-error>
                        }
                        <mat-hint>numbers only</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Minimum ACT</mat-label>
                        <input matInput formControlName="MinACT" />
                        @if (requirementsForm.get('MinACT').hasError('validateNumber')) {
                        <mat-error>invalid response</mat-error>
                        }
                        <mat-hint>numbers only</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Minimum CLT</mat-label>
                        <input matInput formControlName="MinCLT" />
                        @if (requirementsForm.get('MinCLT').hasError('validateNumber')) {
                        <mat-error>invalid response</mat-error>
                        }
                        <mat-hint>numbers only</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Minimum Community Service</mat-label>
                        <input matInput formControlName="MinCommunityService" />
                        @if (requirementsForm.get('MinCommunityService').hasError('validateNumber')) {
                        <mat-error>invalid response</mat-error>
                        }
                        @if (requirementsForm.get('MinCommunityService').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                        <mat-hint>numbers only</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Minimum Work Hours</mat-label>
                        <input matInput formControlName="MinWorkHours" />
                        @if (requirementsForm.get('MinWorkHours').hasError('validateNumber')) {
                        <mat-error>invalid response</mat-error>
                        }
                        <mat-hint>numbers only</mat-hint>
                    </mat-form-field>

                    @if (requirementsSubmitted === true) {
                    <div>
                        @if (requirementsValid === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Form is not complete or has invalid responses
                            </div>
                        </div>
                        }
                        @if (requirementsEdited === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Responses have not been changed from original
                                values
                            </div>
                        </div>
                        }
                    </div>
                    }

                    <div>
                        <button mat-raised-button type="button" routerLink="/scholarship-list">
                            Back
                        </button>
                        <button mat-flat-button type="submit" class="ml-[10px]">
                            Save Tab Changes
                        </button>
                    </div>
                </div>
            </form>
            }
        </mat-tab>
        <mat-tab label="General">
            @if (loading === false) {
            <form [formGroup]="generalForm" (ngSubmit)="generalSave(generalForm)">
                <div class="flex flex-col items-center p-[30px]">
                    <mat-form-field class="w-[90%]">
                        <mat-label>Adult School Eligible?</mat-label>
                        <input matInput formControlName="AdultSchoolEligible" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Tech Training Usage Allowed?</mat-label>
                        <input matInput formControlName="TechTrainingUsageAllowed" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Hard Copy Application?</mat-label>
                        <input matInput formControlName="HardCopyApp" maxlength="200" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Year Established</mat-label>
                        <input matInput formControlName="YearEstablished" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Scholarship Type (Financial)</mat-label>
                        <input matInput formControlName="ScholarshipType" maxlength="20" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Endowed Total (Amount Invested)</mat-label>
                        <input matInput formControlName="EndowedTotal" maxlength="20" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>How Scholarship Paid</mat-label>
                        <textarea matInput formControlName="HowScholarshipPaid" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="300" #HowScholarshipPaid></textarea>
                        <mat-hint align="end">{{ HowScholarshipPaid.value.length }}/300</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Commitment Form Received</mat-label>
                        <input matInput formControlName="CommitmentFormReceived" maxlength="20" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Terms Form Received</mat-label>
                        <input matInput formControlName="DonorTermsFormReceived" maxlength="20" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Number of Scholarships Awarded</mat-label>
                        <input matInput formControlName="NbrScholarshipsAwarded" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Amount Awarded</mat-label>
                        <input matInput formControlName="AmountAwarded" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Total Amount Available</mat-label>
                        <input matInput formControlName="TotalAmountAvailable" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Scholarship Distribution</mat-label>
                        <input matInput formControlName="ScholarshipDistribution" maxlength="150" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Renewal Eligibility Special Requirements</mat-label>
                        <textarea matInput formControlName="RenewalEligibilitySpecialRequirements" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="500" #RenewalEligibilitySpecialRequirements></textarea>
                        <mat-hint align="end">{{
                            RenewalEligibilitySpecialRequirements.value
                            .length
                            }}/500</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Financial Need</mat-label>
                        <input matInput formControlName="FinancialNeed" maxlength="50" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Narrowing - Students With/Without Jobs</mat-label>
                        <textarea matInput formControlName="StudentEmploymentNarrowing" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="200" #StudentEmploymentNarrowing></textarea>
                        <mat-hint align="end">{{
                            StudentEmploymentNarrowing.value.length
                            }}/200</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Narrowing - Donor Specfic</mat-label>
                        <textarea matInput formControlName="DonorSpecficNarrowing" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="1500" #DonorSpecficNarrowing></textarea>
                        <mat-hint align="end">{{
                            DonorSpecficNarrowing.value.length
                            }}/1500</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Ranking Priorities</mat-label>
                        <textarea matInput formControlName="RankingPriorities" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="250" #RankingPriorities></textarea>
                        <mat-hint align="end">{{ RankingPriorities.value.length }}/250</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Selection Process</mat-label>
                        <textarea matInput formControlName="SelectionProcess" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="250" #SelectionProcess></textarea>
                        <mat-hint align="end">{{ SelectionProcess.value.length }}/250</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Interviews Required</mat-label>
                        <input matInput formControlName="InterviewsRequired" maxlength="50" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Number of Applicants To Interview</mat-label>
                        <input matInput formControlName="NbrApplicantsToInterview" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Interview Screening Notes</mat-label>
                        <textarea matInput formControlName="InterviewScreeningNotes" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="250" #InterviewScreeningNotes></textarea>
                        <mat-hint align="end">{{
                            InterviewScreeningNotes.value.length
                            }}/250</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Additional Info to Include in Award
                            Letter</mat-label>
                        <textarea matInput formControlName="AwardLetterInfoToInclude" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="200" #AwardLetterInfoToInclude></textarea>
                        <mat-hint align="end">{{
                            AwardLetterInfoToInclude.value.length
                            }}/200</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Special Notes</mat-label>
                        <textarea matInput formControlName="SpecialNotes" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="1500" #SpecialNotes></textarea>
                        <mat-hint align="end">{{ SpecialNotes.value.length }}/1500</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Transcripts Needed For Renewal?</mat-label>
                        <input matInput formControlName="TranscriptsNeededForRenewal" maxlength="25" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Presenting?</mat-label>
                        <input matInput formControlName="DonorPresenting" maxlength="150" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Who Will Present</mat-label>
                        <input matInput formControlName="WhoWillPresent" maxlength="150" />
                    </mat-form-field>

                    @if (generalSubmitted === true) {
                    <div>
                        @if (generalValid === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Form is not complete or has invalid responses
                            </div>
                        </div>
                        }
                        @if (generalEdited === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Responses have not been changed from original
                                values
                            </div>
                        </div>
                        }
                    </div>
                    }

                    <div>
                        <button mat-raised-button type="button" routerLink="/scholarship-list">
                            Back
                        </button>
                        <button mat-flat-button type="submit" class="ml-[10px]">
                            Save Tab Changes
                        </button>
                    </div>
                </div>
            </form>
            }
        </mat-tab>
        <mat-tab label="Contact Info">
            @if (loading === false) {
            <form [formGroup]="contactForm" (ngSubmit)="contactSave(contactForm)">
                <div class="flex flex-col items-center p-[30px]">
                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Name</mat-label>
                        <input matInput formControlName="DonorName" maxlength="200" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Address</mat-label>
                        <input matInput formControlName="DonorAddress" maxlength="60" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor City</mat-label>
                        <input matInput formControlName="DonorCity" maxlength="30" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor State</mat-label>
                        <mat-select matInput formControlName="DonorState">
                            <mat-option>Select...</mat-option>
                            <mat-option value="FL">Florida</mat-option>
                            <mat-divider></mat-divider>
                            @for (state of allStates; track state.Name) {
                            <mat-option [value]="state.Abbreviation">{{ state.Name }}</mat-option>
                            }
                        </mat-select>
                        @if (contactForm.get('DonorState').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Zip</mat-label>
                        <input matInput formControlName="DonorZip" />
                        @if (contactForm.get('DonorZip').hasError('validateZipCode')) {
                        <mat-error>invalid zip code</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Phone</mat-label>
                        <input matInput formControlName="DonorPhone" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Donor Email</mat-label>
                        <input matInput formControlName="DonorEmail" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Additional Contact</mat-label>
                        <input matInput formControlName="AdditionalContact" maxlength="150" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Secondary Address</mat-label>
                        <input matInput formControlName="SecondaryAddress" maxlength="60" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Secondary City</mat-label>
                        <input matInput formControlName="SecondaryCity" maxlength="30" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Secondary State</mat-label>
                        <mat-select matInput formControlName="SecondaryState">
                            <mat-option>Select...</mat-option>
                            <mat-option value="FL">Florida</mat-option>
                            <mat-divider></mat-divider>
                            @for (state of allStates; track state.Name) {
                            <mat-option [value]="state.Abbreviation">{{ state.Name }}</mat-option>
                            }
                        </mat-select>
                        @if (contactForm.get('DonorState').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Secondary Zip</mat-label>
                        <input matInput formControlName="SecondaryZip" />
                        @if (contactForm.get('SecondaryZip').hasError('validateZipCode')) {
                        <mat-error>invalid zip code</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Secondary Email</mat-label>
                        <input matInput formControlName="SecondaryEmail" maxlength="100" />
                    </mat-form-field>

                    <mat-form-field class="w-[90%]">
                        <mat-label>Secondary Phone</mat-label>
                        <input matInput formControlName="SecondaryPhone" maxlength="100" />
                    </mat-form-field>

                    @if (contactSubmitted === true) {
                    <div>
                        @if (contactValid === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Form is not complete or has invalid responses
                            </div>
                        </div>
                        }
                        @if (contactEdited === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Responses have not been changed from original values
                            </div>
                        </div>
                        }
                    </div>
                    }

                    <div>
                        <button mat-raised-button type="button" routerLink="/scholarship-list">
                            Back
                        </button>
                        <button mat-flat-button type="submit" class="ml-[10px]">
                            Save Tab Changes
                        </button>
                    </div>
                </div>
            </form>
            }
        </mat-tab>
        <mat-tab label="Schools">
            @if (loading === false) {
            <form [formGroup]="schoolsForm" (ngSubmit)="schoolsSave(schoolsForm)">
                <div class="flex flex-col items-center p-[30px]">
                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Applicant Pool</mat-label>
                        <textarea matInput formControlName="ApplicantPool" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="500" #ApplicantPool></textarea>
                        <mat-hint align="end">{{ ApplicantPool.value.length }}/500</mat-hint>
                    </mat-form-field>

                    <mat-card class="w-[90%] p-[20px] bg-gray-300">
                        <div class="flex justify-between">
                            <h4>Selected Schools:</h4>
                            <button mat-raised-button type="button" (click)="editSchools()">
                                Edit School List
                            </button>
                        </div>
                        <mat-divider></mat-divider>
                        @if (selectedSchools == null || selectedSchools?.length === 0) {
                        <p>None</p>
                        }
                        <ul>
                            @for (sch of selectedSchools; track sch.SchoolNumber) {
                            <div>
                                <li>
                                    ({{ sch.SchoolNumber }}) - {{ sch.SchoolName }}
                                </li>
                            </div>
                            }
                        </ul>
                    </mat-card>

                    @if (schoolsSubmitted === true) {
                    <div>
                        @if (schoolsValid === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Form is not complete or has invalid responses
                            </div>
                        </div>
                        }
                        @if (schoolsEdited === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Responses have not been changed from original values
                            </div>
                        </div>
                        }
                    </div>
                    }

                    <div class="mt-[20px]">
                        <button mat-raised-button type="button" routerLink="/scholarship-list">
                            Back
                        </button>
                        <button mat-flat-button type="submit" class="ml-[10px]">
                            Save Tab Changes
                        </button>
                    </div>
                </div>
            </form>
            }
        </mat-tab>
        <mat-tab label="Additional Requirements">
            @if (loading === false) {
            <form [formGroup]="additionalForm" (ngSubmit)="additionalSave(additionalForm)">
                <div class="flex flex-col items-center p-[30px]">
                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Additional Question</mat-label>
                        <textarea matInput formControlName="AdditionalQuestion" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="1500" #AdditionalQuestion></textarea>
                        <mat-hint align="end">{{
                            AdditionalQuestion.value.length
                            }}/1500</mat-hint>
                    </mat-form-field>
                    @if (aQInvalid === true) {
                    <small class="error">must select response type(s)</small>
                    }

                    <mat-radio-group class="flex justify-between w-[90%]" formControlName="AqHaveYesNo">
                        <mat-label>Additional question has Yes/No response</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group class="flex justify-between w-[90%]" formControlName="AqYesRequired">
                        <mat-label>Additional question Yes/No question requires a Yes response</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group class="flex justify-between w-[90%]" formControlName="AqHaveText">
                        <mat-label>Additional question has required text response</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </div>
                    </mat-radio-group>


                    <mat-form-field class="w-[90%]" appearance="outline">
                        <mat-label>Essay Subject</mat-label>
                        <textarea matInput formControlName="EssaySubject" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="1000" #EssaySubject></textarea>
                        <mat-hint align="end">{{ EssaySubject.value.length }}/1000</mat-hint>
                    </mat-form-field>

                    <mat-radio-group formControlName="EmployeeName" class="flex justify-between w-[90%]">
                        <mat-label>{{ scholarship.EmployeeName }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="EmployeeLocation" class="flex justify-between w-[90%]">
                        <mat-label>{{
                            scholarship.EmployeeLocation
                            }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="EmployeeSSN" class="flex justify-between w-[90%]">
                        <mat-label>{{ scholarship.EmployeeSSN }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="StoreLocationNumber" class="flex justify-between w-[90%]">
                        <mat-label>{{
                            scholarship.StoreLocationNumber
                            }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="AccountName" class="flex justify-between w-[90%]">
                        <mat-label>{{ scholarship.AccountName }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="AccountNumber" class="flex justify-between w-[90%]">
                        <mat-label>{{ scholarship.AccountNumber }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="ParentName" class="flex justify-between w-[90%]">
                        <mat-label>{{ scholarship.ParentName }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="ParentSSN" class="flex justify-between w-[90%]">
                        <mat-label>{{ scholarship.ParentSSN }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="ParentOrganization" class="flex justify-between w-[90%]">
                        <mat-label>{{
                            scholarship.ParentOrganization
                            }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="ParentDepartment" class="flex justify-between w-[90%]">
                        <mat-label>{{
                            scholarship.ParentDepartment
                            }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="ScholarshipEssay" class="flex justify-between w-[90%]">
                        <mat-label>{{
                            scholarship.ScholarshipEssay
                            }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    <mat-radio-group formControlName="ScholarshipEssay2" class="flex justify-between w-[90%]">
                        <mat-label>{{
                            scholarship.ScholarshipEssay2
                            }}</mat-label>
                        <div>
                            <mat-radio-button [value]="true">Required</mat-radio-button>
                            <mat-radio-button [value]="false">Not Required</mat-radio-button>
                        </div>
                    </mat-radio-group>

                    @if (additionalSubmitted === true) {
                    <div>
                        @if (additionalValid === false || aQInvalid === true) {
                        <div class="summary my-[20px]">
                            <div>
                                Form is not complete or has invalid responses
                            </div>
                        </div>
                        }
                        @if (additionalEdited === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Responses have not been changed from original
                                values
                            </div>
                        </div>
                        }
                    </div>
                    }

                    <div>
                        <button mat-raised-button type="button" routerLink="/scholarship-list">
                            Back
                        </button>
                        <button mat-flat-button type="submit" class="ml-[10px]">
                            Save Tab Changes
                        </button>
                    </div>
                </div>
            </form>
            }
        </mat-tab>
    </mat-tab-group>
</div>